import Api from '@/common/api';

const apiIRS = Api.getApiIRS();
const api = Api.getApi();

export async function requestCustomersApi({ params }) {
  const response = await apiIRS.request('get', '/users', {
    params: { roles: 'customer', ...params },
  });
  const { data, metadata } = response;
  return { data, metadata };
}

export async function requestCustomerDetailApi({ id }) {
  const response = await api.request('get', `/users/${id}`);
  const { data } = response;
  return data;
}
export async function requestUserDetailApi({ id }) {
  const response = await api.request('get', `/users/${id}`);
  const { data } = response;
  return data;
}

export async function requestCreateCustomerApi({ params }) {
  return apiIRS.request('post', '/users', params);
}

export async function requestUpdateCustomerApi({ guid, params }) {
  return apiIRS.request('patch', `/users/${guid}`, params);
}

export async function requestAddCustomerAddressApi({ guid, params }) {
  return apiIRS.request('post', `/users/${guid}/addresses`, params);
}

export async function requestUpsertCustomerAddressApi({ guid, params }) {
  if (params?.id) {
    const { id, ...rest } = params;
    return apiIRS.request('put', `/users/${guid}/addresses/${id}`, rest);
  }
  return apiIRS.request('post', `/users/${guid}/addresses`, params);
}

export async function requestCreateCustomerProfilePictureApi({ guid, file }) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('file_type', 'image');
  formData.append('file_sub_type', 'avatar');
  return apiIRS.request('post', `/users/${guid}/files`, formData);
}

export async function requestDeleteCustomerProfilePictureApi({ guid, userFileId }) {
  return apiIRS.request('delete', `/users/${guid}/files/${userFileId}`);
}

export async function requestGetCustomerLogHistoryApi({ guid, ...params }) {
  const { data, metadata } = await apiIRS.request('get', `/users/${guid}/authentication_log`, {
    params: { ...params },
  });
  return { data, metadata };
}
